export const en = {
  allOpportunitiesPage: {
    page_title: 'All Events',
    header_title: 'Volunteer Events at {{companyName}}',
    empty_state: {
      title: 'No Events Available',
      description:
        'There are currently no volunteer events available. Please check back later.',
      cta_title: 'Something else in mind?',
    },
    categories: {
      all_events: 'All Events',
      events_near_you: 'Events Near You',
      causes_aligned: 'Causes Aligned With {{companyName}}',
      team_specific: 'Team Specific Events',
      team_specific_subheader:
        'Team events for {{companyName}}. Know it’s your team? Go ahead and join! Otherwise, find an open event listed above.',
      filtered_events: 'Filtered Events',
      past_events: 'Past Events',
      ongoing_events: 'Community Actions',
    },
    actions: {
      view_all: 'View All',
      back: 'Back',
    },
    header: {
      welcome: "Let's get Volunteering with {{companyName}}!",
      filters: {
        location_placeholder: 'Location',
        cause_placeholder: 'Cause',
        search_placeholder: 'Search',
        upcoming: 'Upcoming',
        past: 'Past',
        all: 'All Events',
        strategically_aligned: 'Strategically Aligned',
        cancelled: 'Cancelled',
      },
    },
  },
}
